import React, { createContext, useContext, useState, useEffect } from 'react';
import { getSzakfelelosBySzakkod } from '../apis/SzakokFinder';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children, szakKod }) => {
  const [language, setLanguage] = useState('hu'); // Default to Hungarian
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLanguage = async () => {
      if (!szakKod) {
        console.log('LanguageContext: No szakKod provided');
        setLoading(false);
        return;
      }

      try {
        console.log('LanguageContext: Fetching language for szakKod:', szakKod);
        const response = await getSzakfelelosBySzakkod(szakKod);
        console.log('LanguageContext: getSzakfelelosBySzakkod response:', response);
        const kepzesNyelve = response.data?.kepzes_nyelve;
        console.log('LanguageContext: kepzes_nyelve:', kepzesNyelve);
        
        // Set language based on kepzes_nyelve field
        // "angol" -> "en", "magyar" or anything else -> "hu"
        if (kepzesNyelve && kepzesNyelve.toLowerCase() === 'angol') {
          console.log('LanguageContext: Setting language to EN');
          setLanguage('en');
        } else {
          console.log('LanguageContext: Setting language to HU');
          setLanguage('hu');
        }
      } catch (error) {
        console.error('Error fetching language from szakfelelosok:', error);
        // Default to Hungarian on error
        setLanguage('hu');
      } finally {
        console.log('LanguageContext: Loading complete');
        setLoading(false);
      }
    };

    fetchLanguage();
  }, [szakKod]);

  return (
    <LanguageContext.Provider value={{ language, loading }}>
      {children}
    </LanguageContext.Provider>
  );
};
